import { createSelector } from '@reduxjs/toolkit';
import { getImmutableCompatible } from 'src/utils/immutableUtils';
import { getPlainFilters } from 'src/routes/SearchPage/selectors/filtersBase';
import { isEmpty } from 'lodash';
import { name } from './slice';
import type { PreviousFiltersStore } from './types';

const getState = (state): PreviousFiltersStore =>
  getImmutableCompatible(state, name);

export const previousFiltersSelector = createSelector([getState], (state) =>
  getImmutableCompatible(state, 'filters'),
);

export const isSuggestedFiltersShownSelector = createSelector(
  [getState],
  (state) => state.isSuggestedFiltersShown,
);

/**
 * Проверяем актуальность фильтров, которые хранятся в sessionStorage
 * для текущего поиска. Например, фильтры по регионам Турции не будет применимы
 * для поиска по Египту
 */
export const previousFiltersForCurrentSearchSelector = createSelector(
  [previousFiltersSelector, getPlainFilters],
  (previousFilters, activeFilters) => {
    if (!previousFilters) return null;
    const updateFilterArray = (prevFiltersArray, activeFiltersArray) => {
      if (!activeFiltersArray) return [];
      return prevFiltersArray.filter((prevItem) =>
        activeFiltersArray.some((newItem) => newItem.id === prevItem.id),
      );
    };
    const updatedFilters = Object.keys(previousFilters).reduce(
      (result, key) => {
        if (
          key === 'distance_to_city_center' ||
          key === 'hotel_name' ||
          key === 'prices'
        )
          return { ...result, key: previousFilters[key] };

        const updatedArray = updateFilterArray(
          previousFilters[key],
          activeFilters[key],
        );
        if (updatedArray.length > 0) {
          result[key] = updatedArray;
        }

        return result;
      },
      {},
    );
    return isEmpty(updatedFilters) ? null : updatedFilters;
  },
);
